import React, { Component } from "react";
import { notify } from "../../../redux/actions/snack";
import { addMemberToOrganization } from "../../../redux/actions/organizationAction";
import $ from "jquery";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { getUsersOfAnOrganization } from "../../../redux/actions/organizationAction";

import { Alert, Space, Tag } from "antd";

export class InviteModal extends Component {
  state = {
    name: "",
    email: "",
    roleId: "1",
    isSendingInvite: false,
  };
  validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  getPlanTypeColor = (planId) => {
    if (planId == 3) {
      return "#e2a020";
    } else if (planId == 4) {
      return "#516cf5";
    } else if (planId == 5) {
      return "#ff7007";
    } else {
      return "#000";
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  roleChange = (e) => {
    this.setState({ roleId: e.target.value });
  };
  submitInvite = async () => {
    this.setState({ isSendingInvite: true });

    const organization_id =
      this.props.organizationReducer?.currentOrganization?.id;

    if (
      this.props.userReducer?.groupPlan &&
      this.props.userReducer?.groupPlan?.type == "free"
    )
    this.state.roleId = "1";
    console.log(this.state.roleId, "role");
    let planLicenseFlag = false;
    if (
      this.state.roleId == "1" ||
      (this.state.roleId != "1" &&
        this.props.userReducer?.groupPlan?.availableLicenseCount > 0)
    )
      planLicenseFlag = true;

    if (
      this.state.email != this.props?.userReducer?.user?.email &&
      this.state.name != "" &&
      this.validateEmail(this.state.email) &&
      this.state.roleId !== "" &&
      planLicenseFlag
    ) {
      await this.props.addMemberToOrganization({
        email: this.state.email,
        name: this.state.name,
        organization_id: organization_id?.toString(),
        role_id: this.state.roleId,
      });
      $(".close").click();
      this.setState({
        isSendingInvite: false,
        email: "",
        name: "",
        roleId: "",
      });
      this.props.getUsersOfAnOrganization(organization_id);
    } else {
      this.setState({ isSendingInvite: false });
      if (
        !planLicenseFlag &&
        this.props.userReducer?.groupPlan?.type != "free"
      ) {
        this.props.notify(
          "error",
          "No user licenses available. Please purchase user licenses to proceed further"
        );
      } else if (this.state.email === "") {
        this.props.notify("error", "Please enter email.");
      } else if (this.state.name === "") {
        this.props.notify("error", "Please enter name.");
      } else {
        this.props.notify("error", "Please select role");
      }
    }
  };
  render() {
    return (
      <div
        id="inviteModal"
        class="modal fade crt-skill"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div class="modal-dialog">
          <div class="modal-content crt-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                onClick={() =>
                  this.setState({
                    name: "",
                    email: "",
                    roleId: "",
                  })
                }
              >
                &times;
              </button>
              <h4 class="modal-title"> Invite Team Member</h4>
              {this.props.userReducer?.groupPlan?.type != "free" ? (
                <label className="d-block text-dark">
                  No. of User Licenses Available:{" "}
                  <Tag
                    bordered={false}
                    // color={this.getPlanTypeColor(
                    //   this.props.userReducer?.groupPlan?.planId
                    // )}
                    color="#1d262e"
                  >
                    {this.props.userReducer?.groupPlan?.availableLicenseCount}
                  </Tag>
                </label>
              ) : null}
              {/* </div> */}
            </div>
            <div class="modal-body">
              {/* <Alert message={`No of users available : 5`} type="info" showIcon /> */}
              {/* {this.props.userReducer?.groupPlan?.availableLicenseCount < 1 ?
              <Alert message="No user licenses available. Please purchase user licenses to proceed further." type="error" showIcon />
              : null} */}
              <form class="form-contain" action="javascript:void(0)">
                <div class="frm-block">
                  <div className="ip-tl-label">
                    <span className="tl-label">Email Address</span>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter Email"
                      onChange={(e) => this.handleChange(e)}
                      value={this.state.email}
                    />
                  </div>
                </div>
                <div class="frm-block">
                  <div className="ip-tl-label">
                    <span className="tl-label">Name</span>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter Name"
                      value={this.state.name}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
                {this.props.userReducer?.groupPlan &&
                this.props.userReducer?.groupPlan?.type != "free" ? (
                  <div class="frm-block">
                    <div className="ip-tl-label">
                      <label className="d-block text-dark">Assign role</label>
                      {/* <span
                      className={
                        this.state.roleId === "2"
                          ? "badge badge-pill badge-primary-light cursor-pointer"
                          : "badge badge-pill badge-light cursor-pointer"
                      }
                      onClick={() => this.setState({ roleId: "2" })}
                    >
                      Admin
                    </span> */}
                      <span
                        className={
                          this.state.roleId === "3"
                            ? " badge badge-pill badge-primary-light cursor-pointer"
                            : "badge badge-pill badge-light cursor-pointer1"
                        }
                        onClick={() => this.setState({ roleId: "3" })}
                      >
                        View & Edit
                      </span>
                      <span
                        className={
                          this.state.roleId === "1"
                            ? " badge badge-pill badge-primary-light cursor-pointer"
                            : "badge badge-pill badge-light cursor-pointer1"
                        }
                        onClick={(e) => this.setState({ roleId: "1" })}
                      >
                        View Only
                      </span>
                    </div>
                  </div>
                ) : null}
                <div class="frm-btns">
                  <button
                    class="btn btn-outline"
                    data-dismiss="modal"
                    onClick={() =>
                      this.setState({
                        name: "",
                        email: "",
                        roleId: "",
                      })
                    }
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary primary-btn text-center"
                    onClick={() => this.submitInvite()}
                  >
                    {this.state.isSendingInvite ? (
                      <div class="sp sp-circle text-light"></div>
                    ) : (
                      "Invite"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  skillReducer: state.skillReducer,
  userReducer: state.userReducer,
  appReducer: state.appReducer,
  snackReducer: state.snackReducer,
  organizationReducer: state.organizationReducer,
});
export default compose(
  withRouter,
  connect(mapStateToProps, {
    notify,

    getUsersOfAnOrganization,
    addMemberToOrganization,
  })
)(InviteModal);
